'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.find = exports.all = undefined;

var _timezones = require('../data/timezones.json');

var _timezones2 = _interopRequireDefault(_timezones);

var _findWhere = require('./helpers/findWhere');

var _findWhere2 = _interopRequireDefault(_findWhere);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var find = function find(name) {
  return (0, _findWhere2.default)(_timezones2.default, function (timezone) {
    return timezone.name.toLowerCase() === name.toLowerCase();
  });
};

exports.all = _timezones2.default;
exports.find = find;